<template>
  <div class="fantasy-leaderboard">
    <loading-state :state="state"></loading-state>
    <div v-if="leaderboard.length">
      <div v-if="!selectedBoard">
        <div class="stats-table maxwidth left">
          <table class="full">
            <thead>
              <tr class="headrow">
                <th>Rank</th>
                <th>User</th>
                <th>Points</th>
                <th>Chips</th>
                <th>Avg</th>
                <th>Matches</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(board, i) in leaderboard"
                :key="i"
                class="clickable"
                @click="selectABoard(board)"
              >
                <td>{{board.rank}}</td>
                <td>{{board.user.name}}</td>
                <td>{{board.points}}</td>
                <td>{{board.chips}}</td>
                <td>{{(board.points / board.participated_matches.length).toFixed(2)}}</td>
                <td>{{board.participated_matches.length}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="selectedBoard">
        <div class="">
          <button class="clean fullcolor spacebelow" @click="hideBoard">&lt; Show All Users</button>
        </div>
        <h3 class="top-space bottom-space">Matches of {{selectedBoard.user.name}}</h3>
        <div class="stats-table maxwidth left">
          <table class="full">
            <thead>
              <tr class="headrow">
                <th>Match</th>
                <th>Points</th>
                <th>Chips</th>                
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(matchKey, i) in selectedBoard.participated_matches"
                :key="i"
                class="clickable"
                @click="selectAMatch(i)"
              >
                <td :alt="'for match key: ' + matchKey">
                  <span v-if="selectedBoard.match_names">{{selectedBoard.match_names[i]}}</span>
                  <span v-else>{{matchKey}}</span>
                </td>
                <td>
                  <span class="users">{{selectedBoard.match_points[i]}}</span>
                  <span class="mine"
                    v-if="showMyPoints"
                    :class="appState.numberGoodBadClass(selectedBoard.match_points[i], myMatchPoints[matchKey])"
                    >{{myMatchPoints[matchKey]}}</span>
                </td>
                <td>
                  <span class="users">{{selectedBoard.match_chips[i]}}</span>
                  <span class="mine" 
                    v-if="showMyPoints"
                    :class="appState.numberGoodBadClass(selectedBoard.match_chips[i], myMatchChips[matchKey])"
                    >{{myMatchChips[matchKey]}}</span>
                </td>
              </tr>
              <tr class="totalrow">
                <td>Total</td>
                <td>
                  <span class="users">{{selectedBoard.points}}</span>
                  <span class="mine"
                  v-if="showMyPoints"
                  :class="appState.numberGoodBadClass(selectedBoard.points, myBoard.points)"
                  >{{myBoard.points}}</span>
                </td>
                <td>
                  <span class="users">{{selectedBoard.chips}}</span>
                  <span class="mine" v-if="showMyPoints"
                  :class="appState.numberGoodBadClass(selectedBoard.chips, myBoard.chips)"
                  >{{myBoard.chips}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <app-hang-dailog
        :show="dailogPacket.show"
        yesText=""
        @onCancel="hideDailog"
      >
        <user-team-points
        v-if="selectedBoard"
        :contest="contest"
        :forMatchKey="selectedBoard.participated_matches[selectedMatch]"
        :userKey="selectedBoard.user.key"
        :showMyPoints="myMatchChips[selectedBoard.participated_matches[selectedMatch]] != null"
        ></user-team-points>
      </app-hang-dailog>
    </div>
  </div>
</template>
<script>
import { DataState, AppState } from '@/state'
import { FantasyContestLeaderboard } from '@/models/fantasy'
import UserTeamPoints  from '@/components/cricket/fantasy/UserTeamPoints'

export default {
  components: {
    'UserTeamPoints': UserTeamPoints
  },

  props: {
    contest: Object,
  },
  data () {
    return {
      state: DataState.newLoading(),
      leaderboard: [],
      myBoard: null,
      myMatchPoints: {},
      myMatchChips: {},
      showMyPoints: false,
      selectedBoard: null,
      selectedMatch: null,
      dailogPacket: {
        show: false
      }
    }
  },
  mounted() {
    this.fetchData()
  },

  methods: {
    fetchData () {
      this.state.changeToLoading()
      FantasyContestLeaderboard.fetch(this.contest.key).then((res) => {
        this.leaderboard = res.leaderboard
        this.leaderboard.forEach((board) => {
          if (board.user.key == AppState.instance.user.key) {
            this.myBoard = board
          }
        })
        this.state.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.state.changeToError(error)
      })
    },

    selectABoard (board) {
      this.showMyPoints = (this.myBoard && board.user.key != this.myBoard.user.key) 

      this.myMatchPoints = {}
      this.myMatchChips = {}
      let matchMap = {}

      board.participated_matches.forEach((matchKey, index) => {
        matchMap[matchKey] = index
        this.myMatchPoints[matchKey] = null
        this.myMatchChips[matchKey] = null
      })

      if (this.showMyPoints) {
        this.myBoard.participated_matches.forEach((matchKey, index) => {
          const myIndex = matchMap[matchKey]
          if (myIndex != undefined) {
            this.myMatchPoints[matchKey] = this.myBoard.match_points[index]
            this.myMatchChips[matchKey] = this.myBoard.match_chips[index]
          }
        })
      }

      this.selectedBoard = board
      this.selectedMatch = null
    },

    selectAMatch (matchIndex) {
      this.selectedMatch = matchIndex
      this.dailogPacket.show = true
      AppState.showHangDailog('on-left')
    },

    hideBoard () {
      this.hideDailog()
      this.selectedBoard = null
      this.showMyPoints = false
    },

    hideDailog () {
      this.selectedMatch = null
      this.dailogPacket.show = false
      AppState.hideHangDailog()
    }
  }
}
</script>
